import { Router } from '@lightningjs/sdk';
import { LAYOUT_ALIASES, LAYOUT_ENTITIES, LAYOUT_FRONTSPACES } from '@bedrock/fido-sdk';

export const APP_PATH = 'app';
export const SERVICES_ENTITY = 'services';
export const FOLDERS_ENTITY = 'folders';
export const PROFILE_ENTITY = 'profile';
export const LIVES_ENTITY = 'lives';
export const FOLDER_ENTITY = LAYOUT_ENTITIES.folder;
export const PROGRAM_ENTITY = LAYOUT_ENTITIES.program;
export const SEASON_ENTITY = LAYOUT_ENTITIES.season;
export const SEARCH_ENTITY = `${LAYOUT_ENTITIES.frontspace}/${LAYOUT_FRONTSPACES.search}`;
export const SERVICE_ENTITY = LAYOUT_ENTITIES.service;
export const BOOKMARKS_ENTITY = `${LAYOUT_ENTITIES.frontspace}/${LAYOUT_FRONTSPACES.bookmarks}`;

export const BOOKMARKS_PATH = `${APP_PATH}/${BOOKMARKS_ENTITY}`;
export const FOLDER_PATH = `${APP_PATH}/${FOLDER_ENTITY}`;
export const SERVICES_PATH = `${APP_PATH}/${SERVICES_ENTITY}`;
export const PROFILE_PATH = `${APP_PATH}/${PROFILE_ENTITY}`;
export const PROGRAM_PATH = `${APP_PATH}/${PROGRAM_ENTITY}`;
export const SEASON_PATH = `${APP_PATH}/${SEASON_ENTITY}`;
export const SEARCH_PATH = `${APP_PATH}/${SEARCH_ENTITY}`;
export const SERVICE_PATH = `${APP_PATH}/${SERVICE_ENTITY}`;
export const HOME_PATH = `${APP_PATH}/${LAYOUT_ENTITIES.alias}/${LAYOUT_ALIASES.home}`;
export const FRONTSPACE_PATH = `${APP_PATH}/${LAYOUT_ENTITIES.frontspace}`;
export const FOLDERS_PATH = `${APP_PATH}/${FOLDERS_ENTITY}`;
export const LIVES_PATH = `${APP_PATH}/${LIVES_ENTITY}`;
export const AUDIO_PATH = LAYOUT_ENTITIES.audio;
export const RADIO_PATH = LAYOUT_ENTITIES.radio;
export const VIDEO_PATH = LAYOUT_ENTITIES.video;
export const LIVE_PATH = LAYOUT_ENTITIES.live;

export const CORE_PATH = 'core';
export const PAIRING_PATH = `${CORE_PATH}/pairing`;
export const LANDING_PATH = 'landing';
export const SSI_PATH = 'ssi';
export const DEVICE_GATE_PATH = 'device-gate';

export const USAGE_TERMS_PATH = '/terms-of-usage';
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const SUBSCRIPTION_TERMS_PATH = '/terms-of-subscription';
export const LEGAL_CONDITIONS_PATH = '/legal-conditions';
export const ACCESSIBILITY_STATEMENT_PATH = '/accessibility-statement';
export const SETTINGS_PATH = '/settings';
export const INFORMATION_PATH = `${CORE_PATH}/information`;
export const FAQ_PATH = `${CORE_PATH}/faq`;
export const FEEDBACK_PATH = `${CORE_PATH}/feedback`;
export const ACCOUNT_SETTINGS_PATH = `${CORE_PATH}/account_settings`;
export const EXPIRED_SUBSCRIPTION_PATH = `${CORE_PATH}/expired-subscription`;

export const HISTORY_CLEANUP_PAGES = [HOME_PATH, LANDING_PATH];
export const DEEP_LINK_EXCLUSIONS = [
  HOME_PATH,
  LANDING_PATH,
  PAIRING_PATH,
  SSI_PATH,
  INFORMATION_PATH,
  USAGE_TERMS_PATH,
  PRIVACY_POLICY_PATH,
  SUBSCRIPTION_TERMS_PATH,
  LEGAL_CONDITIONS_PATH,
  SETTINGS_PATH,
  FAQ_PATH,
  FEEDBACK_PATH,
  ACCOUNT_SETTINGS_PATH,
  EXPIRED_SUBSCRIPTION_PATH,
  DEVICE_GATE_PATH,
];

export const navigateTo = (...params) => Router.navigate(...params);
export const navigateToAliasHome = (...params) => navigateTo(HOME_PATH, ...params);
export const navigateToFrontspace = (entityId, ...params) => navigateTo(`${FRONTSPACE_PATH}/${entityId}`, ...params);
export const navigateToBookmarksPage = (...params) => navigateTo(BOOKMARKS_PATH, ...params);
export const navigateToFolderPage = (entityId, ...params) => navigateTo(`${FOLDER_PATH}/${entityId}`, ...params);
export const navigateToServicesPage = (...params) => navigateTo(SERVICES_PATH, ...params);
export const navigateToProfilePage = (...params) => navigateTo(PROFILE_PATH, ...params);
export const navigateToProgramPage = (entityId, ...params) => navigateTo(`${PROGRAM_PATH}/${entityId}`, ...params);
export const navigateToSeasonPage = (entityId, ...params) => navigateTo(`${SEASON_PATH}/${entityId}`, ...params);
export const navigateToSearchPage = (...params) => navigateTo(SEARCH_PATH, ...params);
export const navigateToServicePage = (entityId, ...params) => navigateTo(`${SERVICE_PATH}/${entityId}`, ...params);
export const navigateToFoldersPage = (...params) => navigateTo(FOLDERS_PATH, ...params);
export const navigateToLivesPage = (...params) => navigateTo(LIVES_PATH, ...params);
export const navigateToPairingPage = (...params) => navigateTo(PAIRING_PATH, ...params);
export const navigateToAudioPage = (entityId, ...params) => navigateTo(`${AUDIO_PATH}/${entityId}`, ...params);
export const navigateToRadioPage = (entityId, ...params) => navigateTo(`${RADIO_PATH}/${entityId}`, ...params);
export const navigateToVodPage = (entityId, ...params) => navigateTo(`${VIDEO_PATH}/${entityId}`, ...params);
export const navigateToLivePage = (entityId, ...params) => navigateTo(`${LIVE_PATH}/${entityId}`, ...params);
export const navigateToLandingPage = (...params) => navigateTo(LANDING_PATH, ...params);
export const navigateToExpiredSubscriptionPage = (...params) => navigateTo(EXPIRED_SUBSCRIPTION_PATH, ...params);
export const navigateToSettingsPage = (...params) => navigateTo(SETTINGS_PATH, ...params);
export const navigateToInformationPage = (...params) => navigateTo(INFORMATION_PATH, ...params);
export const navigateToUsageTermsPage = (...params) => navigateTo(USAGE_TERMS_PATH, ...params);
export const navigateToLegalConditionsPage = (...params) => navigateTo(LEGAL_CONDITIONS_PATH, ...params);
export const navigateToAccessibilityStatementPage = (...params) => navigateTo(ACCESSIBILITY_STATEMENT_PATH, ...params);
export const navigateToPrivacyPolicyPage = (...params) => navigateTo(PRIVACY_POLICY_PATH, ...params);
export const navigateToFAQPage = (...params) => navigateTo(FAQ_PATH, ...params);
export const navigateToFeedbackPage = (...params) => navigateTo(FEEDBACK_PATH, ...params);
export const navigateToAccountSettingsPage = (...params) => navigateTo(ACCOUNT_SETTINGS_PATH, ...params);
